var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-autocomplete',{attrs:{"label":"Tipo de item","items":_vm.items,"value":_vm.value,"multiple":_vm.multiple,"chips":_vm.chips,"item-value":"id","item-text":"desig","hide-details":"","clearable":"","readonly":_vm.readonly},on:{"input":function($event){_vm.actualizaValor($event)},"change":function($event){_vm.change($event)}}})}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5d3306b2","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/TipoItemSelect.vue
// module id = K3nj
// module chunks = 0